module.exports = __webpack_public_path__ + "static/media/5.d2b413f1.png";